import { useTheme } from '@mui/material';

export const useSxStyles = () => {
  const theme = useTheme();

  return {
    editCell: {
      padding: 0,
      width: theme.spacing(6),
    },
    readCell: {
      width: theme.spacing(6),
    },
    field: {
      '& .MuiInputBase-input': {
        padding: theme.spacing(0.5, 1.75),
      },
    },
  };
};
